<template>
  <div
    v-show="showMonthView"
    :class="[calendarClass, 'vdp-datepicker-calendar']"
    :style="calendarStyle"
    @mousedown.prevent
  >
    <div :class="style['vdp-header']">
      <p
        :class="[style['vdp-prev'], { [style.disabled]: isPreviousYearDisabled(pageTimestamp) }]"
        @click="previousYear"
      />
      <p :class="style['vdp-month-year']" @click="showYearCalendar">{{ pageYearName }}</p>
      <p
        :class="[style['vdp-next'], { [style.disabled]: isNextYearDisabled(pageTimestamp) }]"
        @click="nextYear"
      />
    </div>
    <ul :class="[style['vdp-calendar-wrapper'], style['month-wrap']]">
      <li
        v-for="month in months"
        :key="month.timestamp"
        :class="[
          style['cell'],
          style['month'],
          { [style['selected-month']]: month.isSelected, [style.disabled]: month.isDisabled }
        ]"
        @click.stop="selectMonth(month)"
      >
        {{ month.month }} {{ pageDate.getFullYear() }}
      </li>
    </ul>
  </div>
</template>
<script>
import DateUtils from '../utils/DateUtils'
import style from '../../../scss/_bottompanel.scss'

export default {
  props: {
    showMonthView: Boolean,
    selectedDate: Date,
    pageDate: Date,
    pageTimestamp: Number,
    disabledDates: Object,
    enabledDates: Object,
    calendarClass: String,
    calendarStyle: Object,
    translation: Object,
    allowedToShowView: Function
  },
  data() {
    return { style }
  },
  computed: {
    months() {
      const d = this.pageDate
      const months = []
      // set up a new date object to the beginning of the current 'page'
      const dObj = new Date(d.getFullYear(), 0, d.getDate(), d.getHours(), d.getMinutes())
      for (let i = 0; i < 12; i++) {
        months.push({
          month: DateUtils.getMonthName(i, this.translation.months),
          timestamp: dObj.getTime(),
          isSelected: this.isSelectedMonth(dObj),
          isDisabled: this.isDisabledMonth(dObj)
        })
        dObj.setMonth(dObj.getMonth() + 1)
      }
      return months
    },

    hasEnabledDates() {
      return this.enabledDates && this.enabledDates.dates && this.enabledDates.dates.length > 0
    },

    /**
     * Get year name on current page.
     * @return {String}
     */
    pageYearName() {
      const yearSuffix = this.translation.yearSuffix
      return `${this.pageDate.getFullYear()}${yearSuffix}`
    }
  },
  methods: {
    /**
     * Emits a selectMonth event
     * @param {Object} month
     */
    selectMonth(month) {
      if (month.isDisabled) {
        return false
      }
      this.$emit('selectMonth', month)
    },
    /**
     * Changes the year up or down
     * @param {Number} incrementBy
     */
    changeYear(incrementBy) {
      const date = this.pageDate
      date.setYear(date.getFullYear() + incrementBy)
      this.$emit('changedYear', date)
    },
    /**
     * Decrements the year
     */
    previousYear() {
      if (!this.isPreviousYearDisabled()) {
        this.changeYear(-1)
      }
    },
    /**
     * Checks if the previous year is disabled or not
     * @return {Boolean}
     */
    isPreviousYearDisabled() {
      if (!this.disabledDates || !this.disabledDates.to || this.hasEnabledDates) {
        return false
      }
      return this.disabledDates.to.getFullYear() >= this.pageDate.getFullYear()
    },
    /**
     * Increments the year
     */
    nextYear() {
      if (!this.isNextYearDisabled()) {
        this.changeYear(1)
      }
    },
    /**
     * Checks if the next year is disabled or not
     * @return {Boolean}
     */
    isNextYearDisabled() {
      if (!this.disabledDates || !this.disabledDates.from || this.hasEnabledDates) {
        return false
      }
      return this.disabledDates.from.getFullYear() <= this.pageDate.getFullYear()
    },
    /**
     * Emits an event that shows the year calendar
     */
    showYearCalendar() {
      this.$emit('showYearCalendar')
    },
    /**
     * Whether the selected date is in this month
     * @param {Date}
     * @return {Boolean}
     */
    isSelectedMonth(date) {
      return (
        this.selectedDate &&
        this.selectedDate.getFullYear() === date.getFullYear() &&
        this.selectedDate.getMonth() === date.getMonth()
      )
    },
    /**
     * Whether a month is disabled
     * @param {Date}
     * @return {Boolean}
     */
    isDisabledMonth(date) {
      let disabledDates = false

      if (!this.disabledDates && !this.enabledDates) return false

      if (
        typeof this.disabledDates.to !== 'undefined' &&
        this.disabledDates.to &&
        !this.hasEnabledDates
      ) {
        if (
          (date.getMonth() < this.disabledDates.to.getMonth() &&
            date.getFullYear() <= this.disabledDates.to.getFullYear()) ||
          date.getFullYear() < this.disabledDates.to.getFullYear()
        ) {
          disabledDates = true
        }
      }
      if (
        typeof this.disabledDates.from !== 'undefined' &&
        this.disabledDates.from &&
        !this.hasEnabledDates
      ) {
        if (
          (this.disabledDates.from && // eslint-disable-line no-mixed-operators
            date.getMonth() > this.disabledDates.from.getMonth() &&
            date.getFullYear() >= this.disabledDates.from.getFullYear()) || // eslint-disable-line no-mixed-operators
          date.getFullYear() > this.disabledDates.from.getFullYear()
        ) {
          disabledDates = true
        }
      }
      return disabledDates
    }
  }
}
// eslint-disable-next-line
</script>
